import { Likes } from "../entities/userMatch";
import { LikesParams } from "../entities/getLikesParams";
import { MatchRepository } from "../repositories/MatchRepository";

export class GetMyNewMatches {
	constructor(private repository: MatchRepository) {}
	execute(params: GetMyNewMatchesParams): Promise<Likes[]> {
		return this.repository.getMyNewMatches(params.params);
	}
}

export class GetMyNewMatchesParams {
	constructor(public params: LikesParams) {}
}
